import type { ValueOf } from './ValueOf';

export const ApprovalRules = {
  NON_SEQUENTIAL: 'NON_SEQUENTIAL',
  ANY_CAN_APPROVE: 'ANY_CAN_APPROVE',
  SEQUENTIAL: 'SEQUENTIAL',
} as const;

export type ApprovalRules = ValueOf<typeof ApprovalRules>;
